void import("./integration/MuxElement").then((i) => i.init());
